import { useState, useEffect, useContext } from "react";
import placeholder from "../inc/placeholder.jpg";
import { SiteContext } from "../contexts/SiteContext";
import fetchSite from "../utils/fetchSite";
import { useParams } from "react-router-dom";
import { Paper, Typography, makeStyles, Grid, Fade } from "@material-ui/core";
import LabelIcon from "@material-ui/icons/Label";
import Loading from "../components/Loading";
import Header from "../components/Header";
import AppBar from "../components/AppBar";
import Breadcrumbs from "../components/Breadcrumbs";
import Entries from "../components/Entries";
import People from "../components/People";
import NotFound from "../components/NotFound";
import AdminBar from "../components/AdminBar";
import Banner from "../components/Banner";

function Region() {
  const [loading, setLoading] = useState(true);
  const [region, setRegion] = useState();
  const { selectedSite, setSelectedSite } = useContext(SiteContext);
  const { siteSlug, regionSlug } = useParams();

  const useStyles = makeStyles((region) => ({
    root: {
      flex: 1,
    },
    main: {
      margin: "0 auto",
      padding: "1rem",
      paddingTop: 0,
      maxWidth: process.env.REACT_APP_MAX_WIDTH,
    },
    paper: {
      padding: "1rem",
      marginBottom: "1rem",
    },
    title: {
      color:
        selectedSite && selectedSite.secondaryColor
          ? selectedSite.secondaryColor
          : region.palette.secondary.main,
    },
    featuredImage: {
      width: "100%",
    },
  }));

  const classes = useStyles();

  // This effect sets the selectedSite based on the :siteSlug (first url parameter)
  useEffect(() => {
    fetchSite(siteSlug, setSelectedSite);
  }, [siteSlug, setSelectedSite]);

  // This effect sets the region and uses the selectedSite._id to make sure it's on the right site
  useEffect(() => {
    async function fetchRegion() {
      let res = await fetch(
        `${process.env.REACT_APP_API_URL}/regions?site=${selectedSite._id}`,
        { credentials: "include" }
      );
      res = await res.json();
      if (res.success) {
        res.data = res.data.filter((region) => region.slug === regionSlug);
        setRegion(res.data[0]);
        setLoading(false);
      } else {
        console.error(res.error);
      }
    }
    if (selectedSite) {
      fetchRegion();
    }
  }, [selectedSite, regionSlug]);

  if (loading || !selectedSite) {
    return <Loading />;
  }

  if (!loading && !region) {
    return <NotFound />;
  }

  return (
    <Fade in={typeof region != "undefined"}>
      <div className={classes.root}>
        <AdminBar />
        <Header />
        <AppBar />
        <Banner />
        <Breadcrumbs
          links={[
            {
              name: "Regions",
              url: `/${selectedSite.slug}/regions`,
            },
            {
              name: region.name,
              url: `/${selectedSite.slug}/regions/${region.slug}`,
            },
          ]}
        />
        <main className={classes.main}>
          <Grid container spacing={3}>
            <Grid item sm={12} md={4}>
              <Paper style={{ marginBottom: "1rem" }} className={classes.paper}>
                <img
                  className={classes.featuredImage}
                  src={
                    region.featuredImage
                      ? `${process.env.REACT_APP_FILE_URL}/${region.featuredImage.fileName}`
                      : //: "https://source.unsplash.com/random?collection=1995427&size=500x500"
                      placeholder
                  }
                  alt={`${region.name} featured`}
                />
              </Paper>
            </Grid>
            <Grid item sm={12} md={8}>
              <Paper className={classes.paper}>
                <Typography
                  className={classes.title}
                  gutterBottom
                  component="h2"
                  variant="h6"
                >
                  <LabelIcon /> Region
                </Typography>
                <Typography
                  style={{ marginTop: "1rem" }}
                  gutterBottom
                  component="h2"
                  variant="h5"
                >
                  {region.name}
                </Typography>
                <div
                  dangerouslySetInnerHTML={{ __html: region.description }}
                ></div>
              </Paper>
              {region.entries.length > 0 && <Entries region={region} />}
              {region.people.length > 0 && <People region={region} />}
            </Grid>
          </Grid>
        </main>
      </div>
    </Fade>
  );
}

export default Region;
